type Props = {
  title: string;
  description?: string;
};

const AuthHeading = ({ title, description }: Props) => (
  <div className="mb-8 space-y-2">
    <h2 className="text-2xl font-bold text-card-foreground">{title}</h2>
    {description && <p className="text-sm text-muted-foreground">{description}</p>}
  </div>
);

export default AuthHeading;
